import API, { GET_AUTH } from 'base/api';

export const DELETE_STUDENT = 'DELETE_STUDENT';
export const DELETE_STUDENT_BEGIN = 'DELETE_STUDENT_BEGIN';
export const DELETE_STUDENT_SUCCESS = 'DELETE_STUDENT_SUCCESS';
export const DELETE_STUDENT_ERROR = 'DELETE_STUDENT_ERROR';

export const deleteStudentBegin = () => ({
  type: DELETE_STUDENT_BEGIN
});
  
export const deleteStudentSuccess = ( data ) => ({
  type: DELETE_STUDENT_SUCCESS,
  payload: { data }
});
  
export const deleteStudentError = ( error ) => ({
  type: DELETE_STUDENT_ERROR,
  payload: { error }
});

export function deleteStudent (id){
  return dispatch => {
    dispatch(deleteStudentBegin());
    return fetch(API.DELETE_STUDENT + id, GET_AUTH)
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(deleteStudentSuccess(id));
        console.log(id);
        console.log(json);
        return json;
      })
      .catch(error => dispatch(deleteStudentError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/deleteStudent.js